
import {Component, Ref, Vue,} from "vue-property-decorator";
import SignalSource from "@/components/signalSoure/signal-source.vue";
import Opt from "@/ts/Opt";
import ToolButtonClass from "@/ts/ToolButton";
import ToolButton from "@/views/teacherClassRoom/tool-button.vue";
import ClassroomOther from "@/views/teacherClassRoom/classroom-other.vue";
// import {NumberToUpperCaseF} from "@/filters/numberToUpperCase.filter.js"
import ClassRoomService from "@/services/classRoom.service";
import RTCClient from "../../rtc/RTCClient.js";
import StudyOrOutClass from "@/views/teacherClassRoom/study-or-out-class.vue";
import {IconEnum, RTCUserMark, UserOnlineStatus, UserType} from "@/ts/Enum";
import {
  class_activity_announcement_topic_prefix,
  class_activity_chat_message_topic_prefix,
  class_activity_forced_kick_topic_prefix,
  class_activity_status_topic_prefix,
  teacher_online_status_topic_prefix,
  free_activity_status_topic_prefix
} from '@/ts/Constant'
import {MessageBase} from "@/ts/Announcement";
import RtcChannel from "@/ts/RtcChannel";
import MqttClient from "@/mqtt/mqttClient";
import Materials from "@/ts/Materials";
import util from "@/utils/util";
import {MessageBox} from "element-ui";

const weekdays = [
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];


Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({
  components: {
    StudyOrOutClass,
    ClassroomOther,
    ToolButton,
    SignalSource,
  },
})
export default class TeacherClassRoom extends Vue {
  teacherInfo = null // 当前登录的教师信息，默认为空
  // 页面是否展示loading的标志位。在点击上课、下课按钮、离开页面过程中等场景下会展示loading。
  loading = false
  classId = ''
  gardenId = ''
  // 用户认证token
  token = ''
  leftHeadInfo = ''
  leftHeadTitle = ''
  rightHeadTitle = '直播信号源:'
  // 是否显示本地预览的video标签
  showLocalPreviewVideo = false
  // 隐藏本地预览video标签的原因文案
  hideLocalPreviewVideoReason = ''

  // 视频源选项列表
  videoSourceOptionList = [
    // new Opt(1, '教室摄像头', '后墙摄像头1', 'lwicon-shexiangtou1'),
    new Opt(2, "本机摄像头", "本机电脑自带的摄像头", "lwicon-shexiangtou1"),
    // new Opt(3, "电脑屏幕", "本机电脑的屏幕画面", "lwicon-pingmu"),
    // new Opt(4, '画中画', '屏幕画面是大画面摄像头是小画面', 'lwicon-huazhonghua')
  ]

  // 摄像头和麦克风设备开关列表。麦克风和摄像头默认是开启的状态，页面初始化时也会默认去推送摄像头和麦克风的流。
  defaultLocalDeviceList = [
    // new ToolButtonClass(1, "麦克风开关", "microphone-control-open.svg", "microphone-control-close.svg", '', '', false),
    new ToolButtonClass(2, "音视频开关", "camera-control-open.svg", "camera-control-close.svg", '开启音视频', '关闭音视频', false),
    // new ToolButtonClass(3, '画质控制', "setting-on.png", "setting.png"),
  ]

  // 屏幕设备开关。 屏幕设备默认是关闭状态，页面初始化时，屏幕流默认是不推送的。
  defaultLocalScreen = new ToolButtonClass(1, "屏幕分享", 'screen-control-open.svg', 'screen-control-close.svg', '开启屏幕分享', '关闭屏幕分享', true)
  // 课程状态控制选项集合
  courseStateControlOptionList = [
    new ToolButtonClass(1, "开始上课", "lwicon-shangke", "lwicon-shangke"),
    new ToolButtonClass(
      2,
      "结束上课",
      "lwicon-shexiangtou_guanbi",
      "lwicon-shexiangtou_guanbi"
    ),
  ]

  //课程资料
  materials = []

  subscriptionList = [
    {
      topic: `${class_activity_status_topic_prefix}{classId}`,
      qos: 1,
      pattern: `^${class_activity_status_topic_prefix}{classId}$`,
    },
    {
      topic: `${class_activity_chat_message_topic_prefix}{activityId}`,
      qos: 1,
      pattern: `^${class_activity_chat_message_topic_prefix}{activityId}$`,
    },
    {
      topic: `${class_activity_announcement_topic_prefix}{activityId}`,
      qos: 1,
      pattern: `^${class_activity_announcement_topic_prefix}{activityId}$`,
    },
    {
      topic: `${class_activity_forced_kick_topic_prefix}{classId}`,
      qos: 2,
      pattern: `^${class_activity_forced_kick_topic_prefix}{classId}$`,
    },
  ]
  // 发起者在rtc直播间的认证信息
  rtcAuthInfo = null
  // 发起这的用户身份，默认是教师
  userType = UserType.teacher.toString()
  // 用户的ID
  userId = ''
  // 发起者的展示用名
  displayName = ''
  // 课堂ID码，即RTC频道ID
  classIdCode = ''
  activityMessageBase: MessageBase = null
  rtcChannel: RtcChannel = null
  // mqtt 是否连接成功的标志位
  mqttConnected = false
  // 课堂开始的弹框是否展示标志位
  classStartDialogFlag = false
  // 课堂开始弹框的内容
  classStartDialogContent = ''

  @Ref("oth") readonly othRef

  /**
   * 组件内部路由守卫，在路由跳转离开本页面之前触发。
   *
   * 使用页面销毁前的钩子函数 beforeDestroy 执行本逻辑，无法保证异步执行的推出马良笔双师课堂执行完后再跳转页面。
   * 而 window.onbeforeunload 事件监听在路由跳转时又无法触发。
   * 所以需要使用组件内部的路由守卫，来配合window.onbeforeunload，对本页面的跳转、刷新、关闭等事件做到全方位的监听。
   */
  beforeRouteLeave(to, from, next) {
    console.log('before route leave hook trick !')
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (this.isStudy) {
      let _that = this
      const confirmHtml = `离开本页面将自动结束当前正在进行的课堂，所有参与该课堂的学生将自动被提出课堂，您确定要继续吗？`
      this.$alert(confirmHtml, "自动下课提示", {
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        closeOnClickModal: false,
        showClose: false,
      }).then(() => {
        _that.leaveCurrentPage().then(() => {
          next()
        }).catch(err => {
          RTCClient.instance.dispose()
          console.error(err)
          next()
        })
      }).catch((e) => {
        next(false)
      })
    } else {
      this.leaveCurrentPage().then((res) => {
        next()
      }).catch(err => {
        console.error(err)
        next()
      })
    }

  }

  created(): void {
    window.addEventListener('keydown', this.stopF5Refresh)
  }

  async mounted() {
    // 挂载页面的关闭或者刷新监听事件，在页面关闭或者刷新时，销毁mqtt和rtc相关内容
    window.addEventListener('beforeunload', this.beforeunloadHandler)

    this.gardenId = window.localStorage.getItem('gardenId')
    this.token = window.localStorage.getItem('LWToken')
    let params = this.$route.params

    if (params && params.class_id_code) {
      this.init(params)
      // this.getCameras(this.classId, this.gardenId)
      // 备课资料学生端和教师端只能看到发布备课以后的文件，未发布时，文件不可见
      this.getMaterial(this.activityMessageBase.lesson_id, this.activityMessageBase.date)
      // 计算视频播放器区域的高度
      this.calcVideoAreaHeight()
    } else {
      let confirmTitle = '当前页面参数不合法，您的访问地址可能非法请关闭本页面重新从合法路径访问本页面！'

      this.$elementConfirm(confirmTitle, "提示", {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        closeOnPressEscape: false,
        closeOnHashChange: true
        // type: 'warning'
      }).then(() => {
      })
    }
  }

  /**
   * 阻止页面刷新
   * <p>
   *   目前可以阻止F5刷新，crtl+R刷新，ctrl+F5刷新。
   *   无法阻止点击浏览器刷新按钮刷新，无法阻止用户点击其他按钮后再使用ctrl+R刷新（比如：用户点击的是ctrl+E+R仍然能刷新，用户点击了
   *   ctrl+E再点击ctrl+R也能刷新）
   * </p>
   */
  stopF5Refresh(e) {
    var evt = window.event || e
    var code = evt.keyCode || evt.which
    console.log(e.ctrlKey,  code)
    // 屏蔽F5 和 crtl + R
    if (code == 116 || (e.ctrlKey == true && code == 82)  || (e.ctrlKey == true && code == 116)) {
      if (evt.preventDefault) {
        evt.preventDefault()
      } else {
        evt.keyCode = 0
        evt.returnValue = false
      }
    }
  }

  /**
   * window.onbeforeunload 回调事件。 在页面关闭或者页面刷新时触发。
   *
   * 内部执行马良笔双师课堂退出逻辑，在退出成功后结束本页面。 若退出失败，会弹出提示信息。
   */
  beforeunloadHandler(event) {

    console.log('before unload handle trick')
    this.leaveCurrentPage().then((res) => {
    }).catch(err => {
      console.error(err)
    })
  }

  destroyed(): void {
    window.removeEventListener('beforeunload', this.beforeunloadHandler)
    window.removeEventListener('keydown', this.stopF5Refresh)
  }


  /**
   * 进入教师课堂初始化参数，构造 rtc所需对象, 聊天对象，供后边mqtt推送
   */
  init(params) {

    this.displayName = params.display_name
    this.userId = params.user_id
    this.userType = params.user_type
    // 会议ID，频道ID
    this.classIdCode = params.class_id_code

    const id = params.id
    const prepare_status = params.prepare_status
    const garden_id = params.garden_id
    const garden_name = params.garden_name
    const grade_id = params.grade_id
    const grade_name = params.grade_name
    const class_id = params.class_id
    const class_name = params.class_name
    const class_section = params.class_section
    const subject_name = params.subject_name
    const subject_code = params.subject_code
    const activity_teacher_name = params.activity_teacher_name
    const activity_teacher_id = params.activity_teacher_id
    const year = params.fullYear
    const date = params.date
    const week = params.week
    const activity_name = params.activity_name

    this.leftHeadInfo = activity_name
    // 调用MessageBase的构造方法，生成MessageBase对象。
    this.activityMessageBase = new MessageBase(
      '',
      activity_name,
      'RTC_INTERACTIVE_CLASS',
      1,
      prepare_status,
      garden_id,
      garden_name,
      grade_id,
      grade_name,
      class_id,
      class_name,
      class_section,
      subject_name,
      subject_code,
      activity_teacher_name,
      activity_teacher_id,
      year,
      id,
      date,
      week,
    );
    // 调用RtcChannel的构造方法，生成RtcChannel对象。
    this.rtcChannel = new RtcChannel(
      '',
      this.classIdCode,
      params.displayName,
      activity_teacher_id,
      this.userType,
      RTCUserMark.teacher,
      activity_teacher_name,
      activity_teacher_id
    )

    this.rtcAuthInfo = params.rtc_auth_info
    // 教师进入直播间详情页后就开始上课。
    // 加入直播间
    this.rtc()
    this.connectMqtt()
  }

  /**
   * 连接MQTT服务器
   */
  connectMqtt() {
    MqttClient.instance.end().then(() => {
      const clientId = `${this.filePre$.mqttClientId}T_${this.userId}`
      MqttClient.instance.setClientId(clientId)
      // 设置教师的遗嘱消息，遗嘱消息topic为教师的在线状态，内容为当前教师离线。
      // 学生在马良笔双师课堂内，如果收到了当前活动的发起教师的下线消息后，不需要等待课堂的结束消息，可以直接退出课堂。
      const willMessage = `{"id": "${this.userId}","online_status": "${UserOnlineStatus.offline}"}`
      MqttClient.instance.setWillMessage({
        topic: `${teacher_online_status_topic_prefix}${this.userId}`,
        qos: 2,
        retain: true,
        payload: willMessage
      })
      MqttClient.instance.connect()
      // 注册mqtt回调事件
      this.registerCallBackMqtt()
      // 启动定时器，如果三秒之后，仍然没有连接上mqtt服务器，那么就提示用户连接失败。
      setTimeout(() => {
        if (!this.mqttConnected) {
          const confirmHtml = `和云端班级活动消息服务连接失败，不能发起马良笔双师课堂教学活动。具体请联系系统运维管理员处理。 `
          this.$alert(confirmHtml, "提示", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
            closeOnClickModal: false,
            showClose: false,
          }).then(() => {
            this.$router.push({
              name: 'FusionClass'
            })
          })
        }
      }, 3000)

    })
  }

  /**
   * 注册mqtt回调事件
   */
  registerCallBackMqtt() {
    MqttClient.instance.registerCallBack((eventName, data) => {
      switch (eventName) {
        //连接成功
        case "connect":
          this.mqttConnected = true
          break;
        //    收到信息
        case "message":
          this.processMessage(data);
          break;
        case "close":
          this.mqttClose(data);
      }
    });
  }


  /**
   * mqtt客户端连接关闭回调函数
   *
   * 无论是因为异常原因断开还是主动断开，都会走此回调。
   * 主动退出时，不做任何处理。
   * 如果不是主动退出，不论任何原因，提示用户已经断开，询问用户是否重连。
   *
   * @param initiativeQuit 是否是主动退出。主动退出为true，否则为false
   *
   */
  mqttClose(initiativeQuit) {
    if (initiativeQuit) {
      return
    }
    let _that = this
    const confirmHtml = `您当前和服务端的消息服务器断开连接！造成断开连接的原因可能包括以下两种：<br/>
1.您的账号在其他地方登录并使用了连接消息服务器服务造成将您当前的连接断开；<br/>
2.由于网络连接不通导致您和消息服务器断开。`
    this.$alert(confirmHtml, "断开连接提示", {
      confirmButtonText: "尝试重新连接",
      cancelButtonText: '退出马良笔双师课堂 ',
      dangerouslyUseHTMLString: true,
      showCancelButton: true,
      closeOnClickModal: false,
      showClose: false,
    }).then(() => {
      MqttClient.instance.reconnect()
    }).catch((e) => {
      // console.log(e)
      _that.toRemoteRouter()
    })
  }

  /**
   * 处理收到的mqtt信息
   * 1.发送的公告信息
   * 2.发送的聊天信息
   * 3.活动被强踢下线的消息
   */
  processMessage(data) {
    // 如果消息收到的消息主题是互踢的主题，退出上课。
    this.forcedKickF(data.topic, data.message);
    //所以使用$refs调用子组件的方法来处理消息
    this.othRef.processMessage(data);
  }

  /**
   * 强制踢掉
   *    活动id一致，并且 要踢掉的活动创建时间要在当前活动创建时间之后
   * @param topic
   * @param message
   */
  forcedKickF(topic, message) {
    const pattern = new RegExp(this.subscriptionList[3].pattern, "g");
    // 接收到的消息不是互踢消息，不继续向下执行
    if (!pattern.test(topic)) {
      return;
    }
    if (
      message.kicked_activity &&
      message.kicked_activity.activity_id == this.activityMessageBase.activity_id
    ) {
      // 结束上课
      this.outClass(false);
      let activityTypeName = util.convertActivityTypeToName(
        message.new_activity.activity_type
      );
      let confirmTitle = `<p class="el-message-box_indentTag">当前您正在进行的教学活动被同班级的<span class="el-message-box__highLight">${message.new_activity.teacher_name}</span>老师最新发起的<span class="el-message-box__highLight">${message.new_activity.grade_name}${message.new_activity.subject_name}${message.new_activity.activity_name}(${activityTypeName}})</span>最新活动顶替下线。</p>
    <p class="el-message-box_noteTag color_font-light">（备注：班级最新的教学活动会自动顶替已有教学活动，请老师们自行协商好教学活动发起时间。）</p>
    `;
      let that = this;
      this.$alert(confirmTitle, "强制下线提示", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        showClose: false,
      }).then(() => {
        // that.goQuickFeedBackBasicsHome();
        that.$router.push({
          name: "FusionClass",
          query: {},
        });
      });
    }
  }

  /**
   * 发送教师在线状态mqtt消息
   */
  pubTeacherOnlineStatusMessage(online_status = '') {
    const topic = teacher_online_status_topic_prefix + this.userId
    const onlineStatusMessage = `{"id": "${this.userId}","online_status": "${online_status}"}`
    MqttClient.instance.doPublish({
      topic,
      qos: 2,
      retain: true,
      payload: onlineStatusMessage,
    })
  }

  /**
   * 替换关键词,生成mqtt订阅主题内容
   */
  replaceSubscription() {
    if (this.subscriptionList.length > 0) {
      this.subscriptionList.forEach((x) => {
        if (-1 !== x.topic.indexOf("{classId}")) {
          x.topic = x.topic.replace(
            "{classId}",
            this.activityMessageBase.class_id.toString()
          );
          x.pattern = x.pattern.replace(
            "{classId}",
            this.activityMessageBase.class_id.toString()
          );
        }
        if (-1 !== x.topic.indexOf("{activityId}")) {
          x.topic = x.topic.replace(
            "{activityId}",
            this.activityMessageBase.activity_id
          );
          x.pattern = x.pattern.replace(
            "{activityId}",
            this.activityMessageBase.activity_id
          );
        }
      });
    }
  }

  /**
   * 发送课程结束的mqtt消息
   */
  sendClassStartMessage() {
    this.activityMessageBase.activity_type = 'RTC_INTERACTIVE_CLASS'
    this.activityMessageBase.activity_instruction = 'START_ACTIVITY'
    this.activityMessageBase.instruction_order = 0
    this.sendClassStatusMessage()
  }

  /**
   * 发送课程结束的mqtt消息
   */
  sendClassEndMessage() {
    this.activityMessageBase.activity_type = "RTC_INTERACTIVE_CLASS"
    this.activityMessageBase.activity_instruction = "END_ACTIVITY"
    this.activityMessageBase.instruction_order = 1
    this.sendClassStatusMessage()
  }

  /**
   * 发送课堂状态变更的mqtt消息
   */
  sendClassStatusMessage() {
    // 拼接课堂状态更改的消息的消息
    // 解构赋值，下列代码的意思是，使用received_time、activity_teacher_online_status、
    // activity_teacher_name、activity_teacher_id分别接收activityMessageBase内的同名值。
    // 然后其余未指定的值付给tempMessageObject。
    let {
      received_time,
      activity_teacher_online_status,
      activity_teacher_name,
      activity_teacher_id,
      ...tempMessageObject
    } = this.activityMessageBase

    // 解构赋值。下列代码的意思是，将tempMessageObject内的所有值，加上teacher_id和teacher_name赋值给messageObj
    let messageObj = {
      ...tempMessageObject,
      teacher_id: this.activityMessageBase.activity_teacher_id,
      teacher_name: this.activityMessageBase.activity_teacher_name,
      channel_id: this.classIdCode
    }

    // 向马良笔双师课堂活动（以课堂ID码结尾的topic）发送mqtt消息
    MqttClient.instance.doPublish({
      topic: `${free_activity_status_topic_prefix}${this.classIdCode}`,
      payload: JSON.stringify(messageObj),
      qos: 2,
      retain: true,
    })
    // 如果当前活动信息内存在班级，向班级活动状态主题发送mqtt消息
    if (messageObj.class_id) {
      MqttClient.instance.doPublish({
        topic: this.subscriptionList[0].topic,
        payload: JSON.stringify(messageObj),
        qos: this.subscriptionList[0].qos,
        retain: true,
      })
    }

  }


  /**
   * 订阅主题
   */
  doSubscribeInit() {
    if (this.activityMessageBase) {
      this.subscriptionList.forEach((x, index) => {
        if (index != 0) {
          MqttClient.instance.doSubscribe({topic: x.topic, qos: x.qos});
        }
      });
    }
  }

  /**
   * 取消订阅主题
   * <p>
   *  取消订阅聊天主题、公告主题、互踢消息主题
   * </p>
   */
  doUnSubscribe() {
    this.subscriptionList.forEach((x, index) => {
      if (index != 0) {
        MqttClient.instance.doUnSubscribe({topic: x.topic});
      }
    });
  }

  /**
   * 跳转到远程访问地址
   *
   * mqtt连接失败且选择退出马良笔双师课堂时使用
   */
  toRemoteRouter() {
    window.location.href = this.filePre$.loginUrl + `/moduleEntry?gardenId=${this.gardenId}&token=${this.token}`;
  }

  /**
   * 获取当前是否已经上课
   */
  get isStudy(): boolean {
    //active为true没有上课 false已经上课；
    let active = this.courseStateControlOptionList[0].getActive();
    return !active;
  }

  /**
   * 将课堂ID码复制到剪切板
   */
  copy() {
    if (navigator.clipboard) {
      // clipboard api 复制
      navigator.clipboard.writeText(this.classIdCode);
    } else {
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      // 隐藏此输入框
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      // 赋值
      textarea.value = this.classIdCode;
      // 选中
      textarea.select();
      // 复制
      document.execCommand('copy', true);
      // 移除输入框
      document.body.removeChild(textarea);
    }
    this.$message.success('课堂ID码已复制到剪切板')
  }
  /**
   * 获取当前登录用户 RTC
   */
  rtc() {
    if (this.rtcAuthInfo) {
      // 注册回调
      this.registerCallBack()
      // 加入直播间，开启本地预览
      RTCClient.instance.joinChannel(this.rtcAuthInfo, this.displayName).then(res => {
        // 加入直播间后，开始上课
        this.courseStateSwitch(1)
        // 展示开始上课的提示弹框
        if (this.activityMessageBase.lesson_id) {
          this.classStartDialogContent = '当前课堂是无课节创建的马良笔双师课堂，所有在本班的学生均可在学生马良笔双师课堂模块自动看到本课堂的入口。其他要加入本课堂的老师或学生均只能通过在对应的加入课堂页面手动输入本课堂ID码加入本课堂。请主动将此课堂ID码分享给要加入本课堂的非本班学生人员。'
        } else if (this.activityMessageBase.class_id) {
          this.classStartDialogContent = '当前课堂是通过所选课节创建的马良笔双师课堂，所有在本班的学生均可在学生马良笔双师课堂模块自动看到本课堂的入口。其他要加入本课堂的老师或学生均只能通过在对应的加入课堂页面手动输入本课堂ID码加入本课堂。请主动将此课堂ID码分享给要加入本课堂的非本班学生人员。'
        } else {
          this.classStartDialogContent = '当前课堂是无班级创建的马良笔双师课堂，要加入本课堂的老师或学生均只能通过在对应的加入课堂页面手动输入本课堂ID码加入本课堂。请主动将此课堂ID码分享给要加入本课堂的非本班学生人员。'
        }
        this.classStartDialogFlag = true
      }).catch(err => {
        this.$message('系统异常，请稍后重试！')
      })
    }
  }

  /**
   *  注册回调
   * <P>
   *  onPublisher 会订阅学生的推流
   * </P>
   */
  registerCallBack() {
    RTCClient.instance.registerCallBack((eventName, data) => {
      switch (eventName) {
        case "onReSubscribe":
          //取消订阅,重新订阅
          RTCClient.instance.unRegisterCallBack();
          this.registerCallBack();
          break;
        case "onJoin":
          this.rtcUserOnlineHandle(data)
          break;
        case "onLeave":
          //更新房间用户列表
          this.rtcUserOfflineHandle(data)
          break;
        case "onSubscribeResult":
          break;
        case "onErrorScreenSharePreview":
          //屏幕分享错误
          this.onErrorScreenSharePreview(data);
          break;
        case "onPublisher":
          //收到推送的rtc流
          this.userPublishChange(data);
          break;
      }
    });
  }

  /**
   * 屏幕分享异常
   * <p>
   *   如果是碰到状态码10010（未知错误）或者10013（系统禁止屏幕分享），给出吐司提示。
   *   如果状态码是10012（手动结束屏幕分享）或者10011（分享时取消分享），不给吐司提示。
   *   同时更改屏幕控制按钮的状态
   * </p>
   */
  onErrorScreenSharePreview(error) {
    switch (error.errorCode) {
      // 未知错误
      case 10010:
        this.$message('屏幕共享出现未知错误，将自动切换到本机摄像头进行共享')
        break
      // 系统不允许屏幕分享
      case 10013:
        this.$message('当前系统禁止屏幕共享，将自动切换到本机摄像头进行共享')
        break
      default:
        break
    }
    this.defaultLocalScreen.setActive(true)
  }


  /**
   * 远端用户上线事件
   */
  rtcUserOnlineHandle(onlineUser) {
    const currentUserId = this.rtcAuthInfo.userid
    // 如果上线的用户是当前用户，不做任何处理
    if (onlineUser.userId === currentUserId) {
      return
    }
    // 执行用户列表中的用户上线事件
    this.othRef.userOnline(onlineUser)
  }

  /**
   * 远端用户下线事件
   */
  rtcUserOfflineHandle(offlineUser) {
    const currentUserId = this.rtcAuthInfo.userid
    // 如果下线的用户是当前用户，不做任何处理
    if (offlineUser.userId === currentUserId) {
      return
    }
    this.othRef.userOffline(offlineUser)
  }

  /**
   * 收到推送的rtc流,需要处理消息
   */
  userPublishChange(data) {
    //调用子组件处理rtc消息
    this.othRef.userPublishChange(data);
  }

  /**
   * 动态设置视频video的宽高为16:9
   */
  calcVideoAreaHeight() {
    function cw(_this) {
      _this.$nextTick(() => {
        let videoC = document.getElementById("videoC");
        const height = (videoC.offsetWidth - 2) * (9 / 16) + 30;
        videoC.style.height = Math.floor(height) + "px";
        // console.log(videoC.offsetWidth, videoC.offsetHeight, height)
      });
    }

    let _this = this;
    cw(_this);
    window.onresize = () => {
      return (() => {
        cw(_this);
      })();
    };
  }


  /**
   * 获取摄像头
   */
  getCameras(classId, gardenId) {
    if (!this.classId || this.classId == '0') {
      return
    }
    ClassRoomService.getCameras({id: classId, gardenId: gardenId}).then(
      (res) => {
      }
    );
  }

  /**
   * 获取课节资料
   */
  getMaterial(lessonId, date) {
    // lessonId = 215090
    // date = '2021-10-25'
    // &lessonStage=1&courseMaterialDesign=teaching_plan
    if (!lessonId || !date) {
      this.materials = []
      return
    }
    ClassRoomService.getMaterial({
      lessonId: lessonId,
      date: date,
      lessonStage: "1",
      courseMaterialDesign: null,
    }).then((res) => {
      if (res) {
        let list = []
        res.forEach((e) => {
          let materials1 = new Materials(
            e.id,
            e.name,
            e.path,
            e.size,
            e.courseMaterialId,
            e.courseMaterialDesign,
            e.courseMaterialDesignName,
            e.designSort,
            e.isMain,
            e.lessonStage,
            e.fontTone,
            e.backgroudTone,
            e.lastUpdatorId,
            e.lastUpdateTime
          );
          if (materials1.icon == IconEnum.video) {
          } else {
            materials1.path = this.filePre$.downloadUrl + materials1.path
          }
          list.push(materials1)
        });
        this.materials = list
      } else {
        this.materials = []
      }
    }).catch(() => {
      this.materials = []
    });
  }

  /**
   * 视频源按钮点击处理函数
   *
   * 教室摄像头、本机摄像头、电脑屏幕 按钮点击事件
   *
   * @param {*} val  直播信号源按钮的key值。 1、教室摄像头；2：本机摄像头；3：电脑屏幕，4：画中画
   */
  videoSourceButtonClickHandler(val) {
    function cw(_this) {
      switch (val) {
        case 1:
          // 教室摄像头
          // _this.classroomCamera();
          break;
        case 2:
          // 本机摄像头
          _this.switchToLocalCameraHandler()
          break;
      }
    }

    const index = this.videoSourceOptionList.findIndex(item => item.key === val)
    let currentToolActive = false
    if (index > -1) {
      currentToolActive = this.videoSourceOptionList[index].getActive()
    }
    // 如果当前的工具按钮已经处于选中状态，则点击无任何相应
    if (currentToolActive) {
      return
    }
    const _this = this;
    // 如果选中了电脑屏幕，且当前未开始上课，弹出提示框
    if (val == 3 && !this.isStudy) {
      //需要弹窗了
      let confimTitle =
        '<div style="font-size: 16px;text-indent:2em;line-height: 30px">该功能仅在您开始上课后才支持使用，请点击右下部的“开始上课”按钮进入上课状态后再使用该功能。</div>';

      this.$elementConfirm(confimTitle, "提示", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        // type: 'warning'
      }).then(() => {
      })
    } else {
      cw(_this);
    }
  }

  setOptFlg(val) {
    this.videoSourceOptionList.forEach((e) => {
      if (e.key === val) {
        e.setActive(true);
      } else {
        e.setActive(false);
      }
    });
  }

  /**
   * 教室摄像头
   */
  classroomCamera() {
    let instance = RTCClient.instance;
    // instance.unPublish();
  }

  /**
   * 直播信号源--本机摄像头按钮点击处理函数。
   *
   */
  switchToLocalCameraHandler() {
    // 设置按钮的状态
    this.setOptFlg(2)
    // this.localMicroControl(1, false)
    this.localCameraControl(2, false)
  }

  /**
   * 本机摄像头预览控制
   *
   * <p>
   * 如果当前传入的参数是允许预览，那么就开启预览；否则关闭预览，展示缺省文案
   * </p>
   *
   * @param {boolean} previewStatus 预览状态。 true：可以预览，false：不能预览
   */
  localCameraPreviewControl(previewStatus = true) {
    // 如果当前禁止采集本地摄像头
    if (!previewStatus) {
      RTCClient.instance.stopPreview().then(res => {
        console.log('本机摄像头画面预览结束，开始展示缺省内容')
        // 画面展示区域的标志位更改
        this.showLocalPreviewVideo = false
        // 缺省的文案赋值
        this.hideLocalPreviewVideoReason = '音视频已关闭'
      }).catch(err => {
        console.error(err)
        this.$message('停止本机摄像头画面预览失败，请重试！')
      })
    } else {
      // 如果当前允许采集本机摄像头，且当前正在预览本机摄像头画面当中，开启预览，展示预览画面
      this.showLocalPreviewVideo = true
      this.hideLocalPreviewVideoReason = ''
      this.$nextTick(() => {
        let localVideo = document.getElementById("localVideo");
        RTCClient.instance.startPreview(localVideo).then(res => {
          console.log('开始本机摄像头预览，展示预览画面')
        }).catch(err => {
          console.error(err)
        })
      })
    }

  }

  /**
   * 上下课状态切换
   *
   * @param {*} val 上下课标志位。 1：上课，2：下课
   */
  courseStateSwitch(val: number) {
    if (val == 1) {
      //    开始上课
      this.studyClass()
    } else if (val == 2) {
      this.outClass()
    }
  }

  /**
   * 关闭开始上课弹框
   */
  closeClassStartDialog() {
    this.classStartDialogFlag = false
  }


  /**
   * 本地设备控制按钮点击处理函数
   *
   * @param {number} key 设备的key值。 1：麦克风设备，2：摄像头，3：画质控制（未启用）
   * @param {boolean} activeStatus 当前按钮的活跃状态
   */
  localDeviceControlClickHandler(key: number, activeStatus: boolean) {
    switch (key) {
      case 1:
        //麦克风
        this.localMicroControl(key, activeStatus)
        break;
      case 2:
        // 摄像头控制
        this.localCameraControl(key, activeStatus)
        break;
      case 3:
        // 画质控制
        break;
    }
  }

  /**
   * 屏幕分享按钮控制点击事件处理函数
   *
   * <p>
   *   根据当前按钮的状态，去开始或者关闭屏幕分型流的推送.
   *   如果当前按钮是活跃状态，那么代表着按钮点击之前是非活跃状态（即点击的是红色的图标）。
   *   此时应该是禁止屏幕分享；否则应该是允许屏幕分享。
   *   可以理解为，是否允许屏幕分享，是和按钮最新的状态是相反的。
   * </p>
   */
  screenDeviceControlClickHandler(key: number, activeStatus: boolean) {
    console.log(activeStatus)
    if (!RTCClient.instance.isSupportScreenShare()) {
      let confirmTitle =
        '<div style="font-size: 16px;text-indent:2em;line-height: 30px">您当前使用的浏览器类型或版本不支持使用屏幕分享功能。请更换至以下浏览器类型或版本后再试：\n' +
        'Chrome浏览器72或以上版本，Edge浏览器80或以上版本。</div>';

      this.$elementConfirm(confirmTitle, "提示", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        // type: 'warning'
      }).then(() => {
      })
      // 重置屏幕分享按钮的状态
      this.defaultLocalScreen.setActive(true)
      return
    }

    RTCClient.instance.setScreenPublishStatus(!activeStatus)
    RTCClient.instance.publish().then(res => {
      // 如果按钮为未活跃状态，代表着开始分享屏幕流，给出吐司提示
      if (!activeStatus) {
        this.$message.success('本机屏幕共享中')
      } else {
        // 否则给出停止分享的吐司
        this.$message.success('本机屏幕共享结束')
      }
    }, reject => {
      console.log(reject)
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })

  }

  setStudyFlg(val) {
    this.courseStateControlOptionList.forEach((e) => {
      if (e.key === val) {
        e.setActive(false);
      } else {
        e.setActive(true);
      }
    });
  }

  /**
   * 本地麦克风控制
   * <p>
   *   控制是否推送本机音频流
   *   按钮当前状态如果是活跃状态，那么代表按钮点击之前的状态是非活跃状态（可以理解为点击的是红色图标）
   *   那么此时，对应的操作应该是关闭音频流的推送； 否则，开启音频的推送。
   * </p>
   */
  localMicroControl(key: number, activeStatus: boolean) {
    // 设置音频流的推送状态 (按钮状态为true，禁止推送音频流；否则允许推送音频流)
    RTCClient.instance.setLocalAudioPublishStatus(!activeStatus)
    // 设置完成后，重新推拉流
    RTCClient.instance.publish().then(res => {
      if (!activeStatus) {
        this.$message.success('麦克风已开启')
      } else {
        this.$message.success('麦克风已关闭')
      }
    }, reject => {
      console.log(reject)
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })
  }

  /**
   * 本机摄像头流控制
   *
   * <p>
   *   开启或者关闭本机摄像头视频流的推送以及本机视频预览
   *  按钮当前状态如果是活跃状态，那么代表按钮点击之前的状态是非活跃状态（可以理解为点击的是红色图标）
   *  那么此时，对应的操作应该是关闭本机摄像头流的推送和关闭预览； 否则，开启本机摄像头流的推送和开启预览。
   * </p>
   */
  localCameraControl(key: number, activeStatus: boolean) {
    // 设置音频流的推送状态 (按钮状态为true，禁止推送音频流；否则允许推送音频流)
    RTCClient.instance.setLocalAudioPublishStatus(!activeStatus)
    // 设置是否允许推流
    RTCClient.instance.setLocalCameraPublishStatus(!activeStatus)
    // 停止或者开始本地视频预览
    this.localCameraPreviewControl(!activeStatus)
    // 重新推流
    RTCClient.instance.publish().then(res => {
      if (!activeStatus) {
        this.$message.success('本机音视频分享中')
      }
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })
  }

  /**
   * 开始上课
   */
  studyClass() {
    // 设置按钮的上课状态
    this.setStudyFlg(1)
    // 开始预览和推送本机摄像头流
    this.switchToLocalCameraHandler()
    // 生成活动Id
    const activity_id = util.generateActivityId()
    // 为当前活动的消息基础类赋予活动信息
    this.activityMessageBase.activity_id = activity_id
    // 替换所有mqtt订阅列表内的关键字
    this.replaceSubscription()
    // 发送上课的mqtt消息
    this.sendClassStartMessage()
    // 为rtc活动信息赋予活动信息
    this.rtcChannel.activity_id = this.activityMessageBase.activity_id
    // 发送教师上线消息
    this.pubTeacherOnlineStatusMessage(UserOnlineStatus.online)
    // 调用订阅，订阅公告、聊天、强制剔除消息主题
    this.doSubscribeInit()

  }

  /**
   * 下课
   *
   * <p>
   *  1、取消RTC发布
   *  2、如果是正常退出直播间，发送马良笔双师课堂结束消息；非正常退出（被踢下线），不发送此消息
   *  3、取消订阅聊天消息主题、公告主题、互踢消息主题
   *  4、更改直播间的状态和按钮交互
   *
   * </p>
   */
  outClass(normalExit = true) {
    // function reenterRoom(_this) {
    //   _this.setStudyFlg(2)
    //   // 视频源所有按钮状态置为未选中
    //   _this.setOptFlg(0)
    //   // 切换到本机画面预览
    //   _this.videoSourceButtonClickHandler(2)
    //   _this.loading = false
    // }

    const confirmHtml = `结束课堂将解散所有参与课堂人员，确定要结束吗？`
    this.$alert(confirmHtml, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: '取消',
      dangerouslyUseHTMLString: true,
      showCancelButton: true,
      closeOnClickModal: false,
      showClose: false,
    }).then(() => {
      // 更改上下课的状态
      this.setStudyFlg(2)
      if (normalExit) {
        // 如果教师是正常结束上课，发送课程结束的MQTT
        this.sendClassEndMessage()
        // 发送教师下消息
        this.pubTeacherOnlineStatusMessage(UserOnlineStatus.offline)
      }

      // 教师主动或者被动下课后，直接离开课堂。 具体的离开rtc直播间等业务，是再路由守卫里面实现的。
      setTimeout(() => {
        this.$router.push({
          name: "FusionClass",
          query: {},
        })
      }, 300)
    }).catch((e) => {
      console.log(e)
    })

    // 下面是不退出当前课堂，再当前页面重新初始化课堂的业务逻辑。 暂时保留不动
    // 此段逻辑有重新开始上课后，屏幕会无法正常分享的BUG
    // RTCClient.instance.logout().then((res) => {
    //   reenterRoom(this)
    // }).catch(err => {
    //   if (err && err.errorCode == 10500) {
    //     this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
    //   } else {
    //     this.$message('系统异常，请稍后重试！')
    //   }
    //   reenterRoom(this)
    // });
  }

  /**
   * 离开本页面触发的事件回调
   *
   */
  leaveCurrentPage() {
    return new Promise((resolve, reject) => {
      this.loading = true
      // 关闭页面内未关闭的弹框，比如参数不合法弹框。
      try {
        MessageBox.close()
      }catch (err) {
        console.log('close message box error. perhaps current page dose not have message box.')
        console.error(err)
      }
      // 如果当前正在上课中
      if (this.isStudy) {
        // 发送下课消息
        this.sendClassEndMessage()
        // 发送教师下线消息
        this.pubTeacherOnlineStatusMessage(UserOnlineStatus.offline)
      }
      // 取消订阅主题
      this.doUnSubscribe()
      setTimeout(() => {
        // 销毁mqtt实例
        MqttClient.instance.end().then(() => {
          // 注销RTC的回调
          RTCClient.instance.unRegisterCallBack()
          // 退出直播间
          RTCClient.instance.logout().then((res) => {
            RTCClient.instance.dispose()
            this.loading = false
            resolve(res)
          }).catch(err => {
            RTCClient.instance.dispose()
            this.loading = false
            reject(err)
          })
        })
      }, 300);


    })
  }

  pause() {
    const videoObj = document.getElementById("localVideo") as HTMLMediaElement;
    if (videoObj) {
      videoObj.play();
    }

    // videoObj.requestFullscreen();
  }
}
